import { Link } from "react-router-dom";
import { MaskedLine } from "../components/MaskedLine";
import { ArrowUpRight } from "lucide-react";

export default function NotFoundPage() {
  return (
    <main data-testid="page-not-found" className="ground-paper min-h-[80vh] pt-[104px] pb-16 md:pt-[132px] md:pb-24">
      <div className="wrap max-w-[820px]">
        <span className="series-stamp"><span>404 · Off-script</span></span>
        <h1 className="h-hero mt-10" style={{ fontSize: "clamp(48px, 8vw, 128px)" }}>
          <MaskedLine>This page</MaskedLine>
          <MaskedLine delay={0.1}>is <span className="claim">off-script.</span></MaskedLine>
        </h1>
        <p className="aside mt-8">
          You followed a link that didn&rsquo;t lead anywhere. Try the homepage — or send a brief and we&rsquo;ll point you where you meant to go.
        </p>
        <div className="flex gap-4 mt-10">
          <Link to="/" className="btn-ink">Back to home <ArrowUpRight size={16} /></Link>
          <Link to="/contact" className="btn-outline">Send a brief</Link>
        </div>
      </div>
    </main>
  );
}
